import React, {useContext, useEffect, useState} from 'react';
import { Box, List, makeStyles } from '@material-ui/core';
import TableHeader from './TableHeader';
import Colors from '../../../helpers/Colors';
import { AppContext } from '../../../contexts/AppContext';
import CompletedRow from './CompletedRow';
import PickupRow from './PickupRow';
import { CubbyModalController } from "../cubby-modals/CubbyModalController";
import RouteNames from '../../../contexts/RouteNames';

function Table({ type }) {
    const classes = useStyles();
    const { orders, completedOrders, searchText, currentRouteName } = useContext(AppContext);

    const [filteredOrders, setFilteredOrders] = useState([]);

    useEffect(() => {
        if (searchText !== '') {
            if (type === 'pickup') {
                setFilteredOrders(orders.filter((order) => {
                    return order.externalId.indexOf(searchText) > -1;
                }));
            }

        } else {
            setFilteredOrders([]);
        }
    }, [searchText, type]);

    const renderOrders = () => {
        if (searchText !== '') {
            return filteredOrders.map((order, index) => {
                return (
                    <PickupRow key={order.id} order={order} />
                );
            });
        }
        return orders.map((order, index) => {
            return (
                <PickupRow key={order.id} order={order} />
            );
        });
    }

    const renderCompleteOrders = () => {
        return completedOrders.map((order, index) => {
            return (
                <CompletedRow key={order.id} order={order} />
            );
        });
    }

    return (
        <Box>
            <TableHeader type={type} />

            {currentRouteName === RouteNames.DISPATCHER &&
                <Box className={classes.container}>
                    {type === 'pickup' ?
                        <List
                            className={classes.list}
                            component="div"
                        >
                            {renderOrders()}

                        </List>
                        :
                        <List
                            className={classes.list}
                            component="div"
                        >
                            {renderCompleteOrders(type)}
                        </List>}
                </Box>
            }
            <CubbyModalController />
        </Box>
    );
}

export default Table;


const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        width: '100%',
        flex: 1,
        height: '100%',
    },
    contentOrderIdLabel: {
        color: Colors.textColor,
        opacity: 0.6,
        fontSize: 16,
        fontWeight: '600',
        paddingLeft: 20,
        fontFamily: 'DINNextLTPro-Regular',
    },
    contentLabel: {
        color: Colors.textColor,
        opacity: 0.6,
        fontSize: 16,
        fontWeight: '600',
        fontFamily: 'DINNextLTPro-Regular',
    },
    contentLatedLabel: {
        color: Colors.red,
        opacity: 0.6,
        fontSize: 16,
        fontWeight: '600',
        fontFamily: 'DINNextLTPro-Regular',
    },
    contentItemContainer: {
        display: 'flex',
        flex: 1,
        direction: 'row',
        height: 60,
        borderRadius: 4,
        border: '1px solid #EDEDED',
        marginBottom: 8,
    },
    contentLatedItemContainer: {
        display: 'flex',
        flex: 1,
        direction: 'row',
        height: 60,
        border: '1px solid #EDEDED',
        marginBottom: 8,
        borderRadius: 4,
        backgroundColor: Colors.fadedRed,
    },
    contentIdRowContainer: {
        display: 'flex',
        flex: 1.8,
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    contentRowContainer: {
        display: 'flex',
        flex: 1,
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    contentButtonRowContainer: {
        display: 'flex',
        flex: 1.5,
        height: '100%',
        justifyContent: 'flex-end',
        paddingRight: 15,
        alignItems: 'center',
    },
    contentRowStatusView: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: 5.5,
    },
    channelLogo: {
        height: 50,
        width: '55%',
        objectFit: 'contain',
    },
    statusLabel: {
        fontSize: 14,
        color: Colors.textColor,
        fontFamily: 'DINNextLTPro-Regular',
    },
    tickIcon: {
        height: 10,
        width: 10,
        objectFit: 'contain',
    },
    dispatchIcon: {
        height: 32,
        width: 32,
        objectFit: 'contain',
    },
    dispatchButtonLabel: {
        marginLeft: 20,
        color: Colors.white,
        fontSize: 18,
        fontFamily: 'DINNextLTPro-Regular',
    },
    statusStepsContainer: {
        display: 'flex',
        flex: 0.9,
        flexDirection: 'row',
        alignItems: 'center',
        height: 50,
    },
    statusStepItemContainer: {
        height: 40,
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    statusStepLastItemContainer: {
        height: 40,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    stepIconsContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    stepIconsView: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors.white,
        height: 20,
        width: 20,
        borderRadius: 20,
        border: `1px solid ${Colors.blue}`,
    },
    stepCompletedIconsView: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors.blue,
        height: 20,
        width: 20,
        borderRadius: 20,
        border: `1px solid ${Colors.blue}`,
    },
    stepIconBackground: {
        height: 4,
        flex: 1,
        backgroundColor: Colors.fadedBlue,
    },
    buttonContentContainer: {
        cursor: 'pointer',
        minHeight: 40,
        maxHeight: 40,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: Colors.boldBlue,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    disabledButtonContentContainer: {
        cursor: 'pointer',
        minHeight: 40,
        maxHeight: 40,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: 'rgba(25, 136, 252, 0.3)',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    warningIcon: {
        height: 10,
        width: 10,
        objectFit: 'contain',
    },
    timerContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    timerWarningIconContainer: {
        height: 18,
        width: 18,
        borderRadius: 20,
        marginLeft: 6,
        backgroundColor: Colors.red,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    list: {
        height: '100%',
        overflow: 'auto',
        width: '100%',
        borderRadius: 4,
    },
}));
